export default __webpack_public_path__ + "static/media/oil-and-gas.b9651939.png";